import { useCallback } from 'react';
import styled from 'styled-components';

// Utils && Hooks
import { useAdobeTracking } from '../../../../hooks';

// Types
import { FormValueErrors } from '../AdditionalInformation.types';

const NotificationSection = styled.div`
  margin-top: 1rem;
  border-radius: 4px;
  background: #f4dedc;
  color: #9f3b32;
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;

  p {
    margin: 0;
    font-size: 0.875rem;
  }
`;

interface FormErrorNotificationProps {
  formErrors: FormValueErrors;
}

export const FormErrorNotification = ({
  formErrors,
}: FormErrorNotificationProps) => {
  const { trackClick } = useAdobeTracking();
  const displayErrorMessage = useCallback(
    (errors: FormValueErrors): string[] => {
      const firstError = Object.values(errors).filter((error) => !!error);
      trackClick({
        type: 'Gaming Hub ',
        subType: 'Additional Information Modal',
        event: 'error',
        errorMessage: firstError[0],
        eventText: 'form has an error',
        eventIndex: '0',
      });
      return firstError[0];
    },
    [trackClick]
  );

  return (
    <NotificationSection role="alert">
      <p>{displayErrorMessage(formErrors)}</p>
    </NotificationSection>
  );
};

export default FormErrorNotification;
